var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMapaDelEmpleo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.323 5.315a1.99 1.99 0 10-.001-3.98 1.99 1.99 0 000 3.98zM7.997 5.315a1.99 1.99 0 10-.001-3.98 1.99 1.99 0 000 3.98zM12.676 5.315a1.99 1.99 0 100-3.98 1.99 1.99 0 000 3.98zM7.997 9.991a1.99 1.99 0 10-.001-3.98 1.99 1.99 0 000 3.98zM7.997 14.667a1.99 1.99 0 10-.001-3.98 1.99 1.99 0 000 3.98z",
    fill: "#666674"
  })));
}
export default __webpack_public_path__ + "static/media/icon-mapa-del-empleo.08a2fe1c.svg";
export { SvgIconMapaDelEmpleo as ReactComponent };